import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { containsNetworkError } from '@confluence/network';

import type { BreadcrumbsType } from './useEditorBreadcrumbs';
import type { EditorBreadcrumbsQuery as EditorBreadcrumbsQueryType } from './__types__/EditorBreadcrumbsQuery';

export function handleEditorBreadcrumbsQueryResult(
	data: EditorBreadcrumbsQueryType | undefined,
	error: Error | undefined,
): BreadcrumbsType {
	if (error) {
		if (containsNetworkError(error) || isUnauthorizedError(error)) {
			markErrorAsHandled(error);
		} else {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.PAGE_MODES,
			});
		}
	}

	return (data?.experimentalEditorBreadcrumbs?.breadcrumbs || []) as BreadcrumbsType;
}
